<script lang="ts">
  import { getGtmContainerId } from "$lib/environment"
  import { onMount } from "svelte"
  import {
    OneTrustCategory,
    flushGtmBuffer,
    gtag,
    loadGoogleTagManager,
    setGrantedCategories,
  } from "."

  function getConsentState(
    category: OneTrustCategory,
    groups: OneTrustCategory[]
  ) {
    return groups.includes(category) ? "granted" : "denied"
  }
  export let isWebView = false

  const WEBVIEW_IMPLIED_CONSENT_CATEGORIES: OneTrustCategory[] = [
    OneTrustCategory.strictlyNecessary,
    OneTrustCategory.performance,
    OneTrustCategory.functional,
  ]

  function handleConsentChange(event: CustomEvent<OneTrustCategory[]>) {
    setGrantedCategories(event.detail)
    gtag([
      "consent",
      "default",
      {
        ad_storage: getConsentState(OneTrustCategory.targeting, event.detail),
        analytics_storage: getConsentState(
          OneTrustCategory.performance,
          event.detail
        ),
        functionality_storage: getConsentState(
          OneTrustCategory.functional,
          event.detail
        ),
        personalization_storage: getConsentState(
          OneTrustCategory.strictlyNecessary,
          event.detail
        ),
        security_storage: getConsentState(
          OneTrustCategory.strictlyNecessary,
          event.detail
        ),
        wait_for_update: 500,
      },
    ])
    const gtmContainerId = getGtmContainerId()
    if (gtmContainerId) {
      loadGoogleTagManager(gtmContainerId)
    }
  }

  function initializeOneTrust() {
    if (isWebView) {
      window.dispatchEvent(
        new CustomEvent("OneTrustGroupsUpdated", {
          detail: WEBVIEW_IMPLIED_CONSENT_CATEGORIES,
        })
      )
    } else {
      createScript(
        "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js",
        "b01342ba-67b5-4080-933e-d17d3e85fdee"
      )
    }
  }

  window.addEventListener("snowPlowLoaded", flushGtmBuffer)
  window.addEventListener("OneTrustGroupsUpdated", handleConsentChange)

  initializeOneTrust()

  onMount(() => {
    return () => {
      window.removeEventListener("snowPlowLoaded", flushGtmBuffer)
      window.removeEventListener("OneTrustGroupsUpdated", handleConsentChange)
    }
  })

  function createScript(src: string, domainScript?: string) {
    const scriptTag = document.createElement("script")
    scriptTag.src = src
    if (domainScript) {
      scriptTag.dataset.domainScript = domainScript
    }
    const earliestScriptTagMounted = document.getElementsByTagName("script")[0]
    scriptTag.type = "text/javascript"
    earliestScriptTagMounted.parentNode?.insertBefore(
      scriptTag,
      earliestScriptTagMounted
    )
    return scriptTag
  }
</script>
